import styled from 'styled-components';
import { makeStyles } from '@material-ui/core';

export const StyledInputContainer = styled.div`
  width: 464px;

  .MuiButton-contained {
    margin-top: 24px;
    margin-bottom: 32px;
  }
`;

export const useStyles = makeStyles({
  root: {
    fontSize: '16px',
  },
});

export const ProgressContainer = styled.div`
  margin-left: 210px;
  margin-top: 70px;
`;

export const ButtonContainer = styled.div`
  margin-top: 24px;
`;

export const StyledContainer = styled.div`
  max-width: 1254px;
  width: 100;
  margin-right: 24px;

  font-family: SourceSansPro;
`;

export const StyledHeaderRow = styled.div`
  display: flex;
  margin-bottom: 15px;
  padding: 0 8px;
`;

export const StyledHeaderCell = styled.div<{ maxWidth?: string }>`
  font-weight: bold;
  font-size: 16px;
  flex: 1;
  line-height: 24px;
  padding-top: 6px;
  max-width: ${({ maxWidth }): string => maxWidth || '100%'};
`;

export const StyledCheckboxCell = styled.div<{ maxWidth?: string }>`
  font-weight: bold;
  font-size: 16px;
  flex: 1;
  line-height: 24px;
  max-width: ${({ maxWidth }): string => maxWidth || '100%'};
`;

export const StyledCell = styled.div<{ maxWidth?: string }>`
  word-break: break-word;
  flex: 1;
  line-height: 30px;
  padding-right: 10px;
  padding-top: 5px;
  max-width: ${({ maxWidth }): string => maxWidth || '100%'};
`;

export const StyledRowContainer = styled.div`
  display: flex;
  font-size: 16px;
  padding: 8px;

  &:nth-child(odd) {
    background-color: #fafafa;
  }
`;

export const StyledDownloadButtonsContainer = styled.div`
  display: flex;
  align-items: center;

  & > button {
    margin-right: 6px;
  }
`;
